import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  @media (min-width: 980px) {
    margin-top: -120px;
  }
  @media (min-width: 540px) and (max-width: 980px) {
    margin-top: -60px;
  }
`

const Big = styled.div`
  position: relative;
  width: 100%;
  @media (min-width: 980px) {
    height: 500px;
  }
  @media (min-width: 540px) and (max-width: 980px) {
    height: 300px;
  }
  @media (max-width: 540px) {
    height: 260px;
  }
  span {
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  i {
    background: url(/images/zoom_foto.png) no-repeat center;
    height: 41px;
    width: 41px;
    position: absolute;
    bottom: 3px;
    right: 3px;
  }
  .box {
    background: rgba(0, 0, 0, 0.4);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 30;
    overflow: auto;
    img {
      height: 90%;
    }
  }
`

const Options = styled.div`
  display: flex;
  align-content: space-between;
  margin-top: 25px;
  width: 100%;
  @media (min-width: 980px) {
    height: 142px;
  }
  @media (min-width: 789px) and (max-width: 980px) {
    height: 112px;
  }
  @media (max-width: 789px) {
    height: 72px;
  }
  .holder {
    margin: 0 8px;
    width: 100%;
    display: flex;
    overflow: hidden;
    div {
      transition: all 0.3s;
      display: flex;
      width: 100%;
    }
    span {
      margin: 0 8px;
      display: inline-block;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      .overlay {
        background: rgba(0, 0, 0, 0.4);
        position: absolute;
        top: 0;
        left: -8px;
        right: 0;
        bottom: 0;
        transition: all 0.3s;
        opacity: 0;
        min-width: 100%;
      }
      &:hover {
        .overlay {
          opacity: 1;
        }
      }
      @media (min-width: 980px) {
        height: 142px;
        min-width: calc(50% - 16px);
      }
      @media (min-width: 789px) and (max-width: 980px) {
        height: 112px;
        min-width: calc(100% - 16px);
      }
      @media (max-width: 789px) {
        height: 72px;
        min-width: calc(50% - 16px);
      }
    }
  }
  button {
    min-width: 82px;
    background: #fff;
    border-radius: 3px;
    border: 0;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
    transition: background-color 0.3s;
    @media (min-width: 980px) {
      height: 142px;
    }
    @media (min-width: 789px) and (max-width: 980px) {
      height: 112px;
    }
    &.right {
      background-image: url(/images/arrow-right-bold.png);
    }
    &.left {
      background-image: url(/images/arrow-left-bold.png);
    }
    &:hover {
      background-color: #E59134;
      &.right {
        background-image: url(/images/arrow-right.png);
        background-size: 22px 16px;
      }
      &.left {
        background-image: url(/images/arrow-right.png);
        background-size: 22px 16px;
        transform: rotate(180deg);
      }
    }
  }
`

class Gallery extends Component {
  state = {
    active: 0,
    total: 0,
    slide: 0,
    slide_total: 0,
    pace: 0,
    big: false,
  }

  componentDidMount = () => {
    this.setState({ active: 0, pace: 50, total: this.props.galeria.length, done: true, slide_total: this.props.galeria.length - 2 });
    window.addEventListener("resize", this.resize.bind(this));
    this.resize()
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize);
  }

  resize = () => {
    if (document.body.clientWidth > 789 && document.body.clientWidth < 980) {
      this.setState({ pace: 100, slide_total: this.props.galeria.length - 1 });
    } else {
      this.setState({ pace: 50, slide_total: this.props.galeria.length - 2 });
    }
  }

  slideLeft = () => {
    if (this.state.slide > 0) {
      this.setState({ slide: this.state.slide - 1});
    }
  }

  slideRight = () => {
    if (this.state.slide < this.state.slide_total) {
      this.setState({ slide: this.state.slide + 1});
    }
  }

  render = () => {
    const {galeria} = this.props
    return (
      <Container>
        <Big>
          <span onClick={ (e) => { this.setState({big: true})} } style={ { backgroundImage: `url(${galeria[this.state.active].imagem.url})` } }>
            {
              galeria[this.state.active].zoom.url && (
                <i></i>
              )
            }
          </span>
          
          {
            (galeria[this.state.active].zoom.url && this.state.big) && (
              <div className="box" onClick={ (e) => { this.setState({big: false})} }>
                <img alt="" src={ galeria[this.state.active].zoom.url } />
              </div>
            )
          }
        </Big>
        <Options>
          <button className="left" onClick={ this.slideLeft }></button>
          <div className="holder">
            <div style={ { transform: `translateX(-${this.state.slide * this.state.pace}%)`}}>
              {
                galeria.map((item, index) => {
                  return (
                    <span key={ index } onClick={ (e) => { this.setState({active: index}) }} style={ { backgroundImage: `url(${item.thumbnail.url})` } }>
                      <span className="overlay"></span>
                    </span>
                  )
                })
              }
            </div>
          </div>
          <button className="right" onClick={ this.slideRight }></button>
        </Options>
      </Container>
    )
  }
}

Gallery.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

export default Gallery;
